import { Response } from './domain/Collection';
import Connection from './domain/Connection';
import Configuration from "./domain/Configuration";
import HttpError from "./errors/HttpError";
import {v4 as uuidv4} from "uuid";

const fetch = require('node-fetch');

const buildUrl = ((baseUrl, params) => {
    const url = new URL(baseUrl);
    const urlParams = new URLSearchParams(url.search);

    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            urlParams.set(key, value);
        });
    }

    url.search = urlParams.toString();

    return url.href; // Return a string of the whole URL
});

export const login = async (email, password, baseUrl = 'http://localhost:8080', args = {}) => {
    const {
        params = {},
    } = args;
    const loginResponse = await fetch(buildUrl(`${baseUrl}/user/login`, params), {
        credentials: 'include',
        method: 'post',
        headers: {
            'Content-type': 'application/json',
            Accept: 'application/json',
            'Accept-Charset': 'utf-8',
        },
        body: JSON.stringify({
            attributes: {
                username: email,
                password: password,
            },
        }),
    });

    const cookieHeader = loginResponse.headers.raw()['set-cookie'];
    const cookie = cookieHeader ? cookieHeader[0] : undefined;
    const respJson = await loginResponse.json();
    const collectionData = {...respJson, data: [respJson.data]};
    return new Response({data: collectionData, connection: new Connection({data: {authToken: cookie}})});
};
